import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../provider/CommonContext";
import { Container, Col, Row, Button, Tab, Tabs, Table, Accordion } from "react-bootstrap";
import './HistoricalNav.css';
import Slider from 'react-slick';
// import marketup from '../../Images/arrow-up.png';
// import marketdown from '../../../Images/Images/arrow-down.png';
import { useNavigate } from "react-router-dom";
import Pagination from '../../CommonUI/Pagination/Pagination';
import { format, parseISO } from 'date-fns';
import MarketMF from "../MarketMF";
import { Vortex } from 'react-loader-spinner'




function HistoricalNav() {
    const { BaseURL } = useContext(URLstateContext);
    const [DataHolding, setDataHolding] = useState([]);
    const [DataMfHoldingdrop, setDataMfHoldingdrop] = useState([]);
    const [DataMfHoldingdropcat, setDataMfHoldingdropcat] = useState([]);
    const [Category, setCategory] = useState('5946');
    const [Sheme, setSheme] = useState('26');
    const [ShemeCode, setShemeCode] = useState('10645');
    const [currentPage, setCurrentPage] = useState(1);
    const [DataMfHoldingDividend, setDataMfHoldingDividend] = useState([]);
    const [valueLi, setValueLi] = useState('1Month');
    const [DataMfHoldingdropSheme, setDataMfHoldingdropSheme] = useState([]);
    const [valuecategory, setValuecategory] = useState([]);
    const [valuecategory1, setValuecategory1] = useState([]);
    const [valuecategory2, setValuecategory2] = useState([]);
    const [loadingshow, setloadingshow] = useState(false);
    let getDataHolding, getDataHoldingdrop,
        getDataHoldingdropcat, getDataHoldingdropSheme;
    let PageSize = 8;

    useEffect(() => {
        setloadingshow(true);
        const getUrlMfTopHoldingDrop = BaseURL + "MfHoldingDrop";

        fetch(`${getUrlMfTopHoldingDrop}/-/-`)
            .then((response) => response.json())
            .then((dataMHoldingdrop) => {
                getDataHoldingdrop = dataMHoldingdrop.data;
                setDataMfHoldingdrop(getDataHoldingdrop);
                var codename = getDataHoldingdrop[0].co_name;
                setValuecategory(codename)
                // setloadingshow(false);

            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/-`)
            .then((response) => response.json())
            .then((dataMHoldingdropcat) => {
                getDataHoldingdropcat = dataMHoldingdropcat.data;
                setDataMfHoldingdropcat(getDataHoldingdropcat);
                var codename = getDataHoldingdropcat[0].VCLASS;
                setValuecategory1(codename)
                // setloadingshow(false);

            })
            .catch((error) => {
            });

        fetch(`${getUrlMfTopHoldingDrop}/${Category}/${Sheme}`)
            .then((response) => response.json())
            .then((dataMHoldingdropSheme) => {
                getDataHoldingdropSheme = dataMHoldingdropSheme.data;
                setDataMfHoldingdropSheme(getDataHoldingdropSheme);
                var codename = getDataHoldingdropSheme[0].SCH_NAME;
                setValuecategory2(codename)
                // setloadingshow(false);

            })
            .catch((error) => {
            });

        const getUrlMfTopHolding = BaseURL + "MFNavHistorical";

        fetch(`${getUrlMfTopHolding}/${ShemeCode}/${valueLi}/-`)
            .then((response) => response.json())
            .then((dataMHolding) => {
                getDataHolding = dataMHolding.data;
                setDataHolding(getDataHolding);
                setloadingshow(false);
            })
            .catch((error) => {
            });
    }, [Category, Sheme, ShemeCode, valueLi]);


    const currentTableData = useMemo(() => {
        if (DataHolding != null && DataHolding != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (DataHolding != null && DataHolding != []) {
                if (DataHolding.length > 0) {
                    return DataHolding.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, DataHolding]);

    return (
        <>
            <div class="col-12 p-0 breadcrumMF ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/mutual-funds">Mutual Fund</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Historical NAV</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='hisnav-loser-sc'>

                            <div className='hisnav-header'>

                                <h2><span>Historical NAV</span></h2>

                            </div>
                            <MarketMF optionValue="Historical NAV" />
                            <div className='hisnav-right'>
                                <div className='Tophisnav-inner-select'>

                                    <select onChange={(event) => setCategory(event.target.value)}>
                                        <option>Select Fund House</option>
                                        {DataMfHoldingdrop && DataMfHoldingdrop.map(
                                            ({ mf_cocode, co_name }) => (

                                                <option value={mf_cocode} selected={valuecategory === co_name}>{co_name}</option>
                                            )
                                        )}
                                    </select>

                                </div>
                                <div className='hisnav-inner-select'>
                                    <select onChange={(event) => setSheme(event.target.value)}>
                                        <option>Select Category</option>
                                        {DataMfHoldingdropcat && DataMfHoldingdropcat.map(
                                            ({ VCLASSCODE, VCLASS }) => (

                                                <option value={VCLASSCODE} selected={valuecategory1 === VCLASS}>{VCLASS}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                                <div className='hisnav-inner-select'>
                                    <select onChange={(event) => setShemeCode(event.target.value)}>
                                        <option>Select Scheme</option>
                                        {DataMfHoldingdropSheme && DataMfHoldingdropSheme.map(
                                            ({ MF_SCHCODE, SCH_NAME }) => (

                                                <option value={MF_SCHCODE} selected={valuecategory2 === SCH_NAME}>{SCH_NAME}</option>
                                            )
                                        )}
                                    </select>
                                </div>
                            </div>
                            <div className='tghisnav-inner-select'>

                                <select onChange={(event) => setValueLi(event.target.value)}>
                                    <option id="1Month" value="1Month" className={(valueLi === "1Month") ? "active" : ''}>1Month</option>
                                    <option value="3month" className={(valueLi === "3month") ? "active" : ''} >3Months</option>
                                    <option value="6month" className={(valueLi === "6month") ? "active" : ''} >6Months</option>
                                    <option value="1year" className={(valueLi === "1year") ? "active" : ''} >1Year</option>

                                </select>
                            </div>
                            <div className='hisnav-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>NAV Date</th>
                                            <th className='text-right'>NAV(&#8377;) </th>
                                            <th className='text-right'>NAV RePrice(&#8377;) </th>
                                            <th className='text-right'>NAV SaPrice(&#8377;) </th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ NAVDATE, NAVRS, NAVREPRICE, NAVSAPRICE }) => (
                                                <tr>

                                                    <td className="text-left">{format(parseISO(NAVDATE), 'dd-MMM-yyyy')}</td>
                                                    <td className='text-right'>{NAVRS.toFixed(2)}</td>
                                                    <td className='text-right'>{NAVREPRICE.toFixed(2)}</td>
                                                    <td className='text-right'>{NAVSAPRICE.toFixed(2)}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                    <Vortex
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="vortex-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="vortex-wrapper"
                                        colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                    />
                                    <div className="model_popup">Please Wait...</div>
                                </div> : ""
                                }
                            </div>

                            {(DataHolding != null && DataHolding != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(DataHolding.length != null) ? DataHolding.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>

                    </Col>
                </Row>
            </Container>
        </>
    )
}

export default HistoricalNav